import { Stack } from '@chakra-ui/react';
import { Text } from '@main/complykit/components/text';
import { defaultStyles } from '@visx/tooltip';
import { CSSProperties, ReactNode, useMemo } from 'react';

export type ChartSegmentTooltipContentProps = {
  label: string;
  value: ReactNode;
};

export function ChartSegmentTooltipContent({ label, value }: ChartSegmentTooltipContentProps) {
  return (
    <Stack spacing={0.5} align="center">
      <Text size="xs" color="inherit">
        {label}
      </Text>
      <Text size="xs" color="inherit" weight="semibold">
        {value}
      </Text>
    </Stack>
  );
}

export const CHART_SEGMENT_TOOLTIP_OFFSET = {
  offsetLeft: 8,
  offsetTop: -28,
} as const;

export const PIE_CHART_TOOLTIP_OFFSET = {
  offsetLeft: 12,
  offsetTop: 12,
} as const;

const CHART_TOOLTIP_BASE = {
  background: 'rgba(0, 0, 0, 0.78)',
  borderRadius: '8px',
  color: 'white',
  fontFamily: 'Inter, arial, sans-serif',
  fontWeight: 400,
} as const;

export function useChartTooltipStyles(): CSSProperties {
  return useMemo(
    () => ({
      ...defaultStyles,
      ...CHART_TOOLTIP_BASE,
      fontSize: '10px',
      lineHeight: '14px',
      padding: '8px 10px',
      textAlign: 'center' as const,
    }),
    [],
  );
}
